<template>
  <WalletWorkPackageBody
    >
    <template #button-top>
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.up"
        direction="up"
        width="80px"
        @click.native="
          nav_direction = 'up',
          $router.push({
            name: getWaggonInfoNavigation.up,
            params: {direction: 'up'}
          })
          "
        />
    </template>
    <template #button-right>
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.right"
        direction="right"
        height="80px"
        @click.native="
          nav_direction = 'right',
          $router.push({
            name: getWaggonInfoNavigation.right,
            params: {direction: 'right'}
          })
          "
        />
    </template>
    <template #button-bottom>
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.down"
        direction="down"
        width="80px"
        @click.native="
          nav_direction = 'down',
          $router.push({
            name: getWaggonInfoNavigation.down,
            params: {direction: 'down'}
          })
          "
        />
    </template>
    <template #button-left>
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.left"
        direction="left"
        height="80px"
        @click.native="
          nav_direction = 'left',
          $router.push({
            name: getWaggonInfoNavigation.left,
            params: {direction: 'left'}
          })
          "
        />
    </template>
    <template #default>
      <transition
        :name="`wallet-workpackage-slide-${$route.params.direction}`"
        >
        <router-view :key="$route.matched[4].name"/>
      </transition>
    </template>
  </WalletWorkPackageBody>
</template>
<script>
import store from '@/store/index'

  import { WalletMixin } from '@/mixins/Wallet.mixin.js'
  export default {
    props: ['project_id', 'takt_index'],
    mixins: [
      WalletMixin
    ],
    beforeRouteEnter(to, from, next) {
      store.dispatch('Ultra/requestUObject', {
          url: [
            {projects: to.params.project_id},
            {trains: to.params.train_id},
            {taktareas: to.params.taktarea_id},
            {twaggons: to.params.twaggon_id},
            {tworkpackages: to.params.tworkpackage_id},
            {showWithEntitiesNormalized: ''}
          ]
        })
        .then(() => {
          next();
        });
    },


    // beforeRouteEnter(to, from, next) {
    //   store.dispatch('TWorkPackage/requestTWorkPackage', {
    //       project_id: to.params.project_id,
    //       train_id: to.params.train_id,
    //       taktarea_id: to.params.taktarea_id,
    //       twaggon_id: to.params.twaggon_id,
    //       twork_package_id: to.params.tworkpackage_id
    //     })
    //     .then(() => {
    //       next();
    //     });
    // },



    // beforeRouteUpdate(to, from, next) {
    //   if (from.params.tworkpackage_id !== to.params.tworkpackage_id) {
    //   store.dispatch('TWorkPackage/requestTWorkPackage', {
    //       project_id: to.params.project_id,
    //       train_id: to.params.train_id,
    //       taktarea_id: to.params.taktarea_id,
    //       twaggon_id: to.params.twaggon_id,
    //       twork_package_id: to.params.tworkpackage_id
    //     })
    //     .then(() => {
    //       next();
    //     });
    //   }
    // },
  }
</script>
<style>
  .wallet-workpackage-slide-up-enter {
    transform: translateY(calc(-100vh + 225px));
  }
  .wallet-workpackage-slide-up-leave-to  {
    transform: translateY(calc(100vh - 225px));
  }
  .wallet-workpackage-slide-right-enter{
    transform: translateX(100%);
  }
  .wallet-workpackage-slide-right-leave-to  {
    transform: translateX(-100%);
  }
  .wallet-workpackage-slide-down-enter {
    transform: translateY(calc(100vh - 225px));
  }
  .wallet-workpackage-slide-down-leave-to  {
    transform: translateY(calc(-100vh + 225px));
  }
  .wallet-workpackage-slide-left-enter{
    transform: translateX(-100%);
  }
  .wallet-workpackage-slide-left-leave-to  {
    transform: translateX(100%);
  }
  .wallet-workpackage-slide-up-enter-active, .wallet-workpackage-slide-up-leave-active,
  .wallet-workpackage-slide-right-enter-active, .wallet-workpackage-slide-right-leave-active,
  .wallet-workpackage-slide-down-enter-active, .wallet-workpackage-slide-down-leave-active,
  .wallet-workpackage-slide-left-enter-active, .wallet-workpackage-slide-left-leave-active {
    transition: all 0.2s ease-in-out;
  }
</style>
